import { Item, ItemProps } from 'react-stately';
import { TooltipContainerProps } from 'components/Tooltip';
import { IconPosition } from './types';

export interface TabItemProps<T> extends ItemProps<T> {
  icon?: React.ReactNode;
  iconPosition?: IconPosition;
  tooltip?: TooltipContainerProps['contents'];
}

// TODO with type declaration merging, maybe we don't need this.  can possibly
// just create react-stately.d.ts
const TabItem = Item as <T>(
  props: TabItemProps<T>,
) => React.ReactElement | null;

export default TabItem;
